import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store/index'
import { getLanguage } from '@/utils/common'

Vue.use(VueI18n)

export default (() => {
  let flowObject = store.getters.flowObject
  let translationsLocation = flowObject.translations.location
  let lng = getLanguage()

  Vue.use(VueI18n)
  return import(`@/plugins/translations/${translationsLocation}`)
    .then((messages) => {
      const i18n = new VueI18n({
        locale: lng,
        fallbackLocale: store.state.defaultLocale, // set fallback locale
        messages: messages.default
      })
      return i18n
    })
})()
